// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"core-view__mainContainer___NRqnw","skipToMainContent":"core-view__skipToMainContent___8WvA-","app-container":"core-view__app-container___1nh58"};